import React, { useEffect, useState } from "react";
import { AbstractUploadInput } from "./AbstractUploadInput";
import { PreviewStage } from "../components/PreviewStage";
import { UniversalLoader } from "oc-threejs/loader/UniversalLoader";
import "./Model3dInput.scss";
import { ReplacingMaterialFactory } from "oc-threejs/loader/ReplacingMaterialFactory";
import * as Scenes from "oc-threejs/Scenes";
import { useLocalStorage } from "oc-ui/react/useLocalStorage";

export const useDummy3dCloneInScene = ({ node, isTopNode }) => {
  const [dummy3d, setDummy3d] = useState(null);
  const [addDummy3dToScene, setAddDummy3dToScene] = useLocalStorage("addDummy3dToScene", false);
  useEffect(() => {
    let clone;
    if (isTopNode && addDummy3dToScene && dummy3d) {
      clone = dummy3d.clone();
      APP.scene.add(clone);
    }
    return () => {
      if (clone) {
        APP.scene.remove(clone);
      }
    };
  }, [addDummy3dToScene, dummy3d, isTopNode]);
  const addDummyCheckbox = (
    <label>
      <input
        type="checkbox"
        checked={addDummy3dToScene as boolean}
        onChange={(e) => setAddDummy3dToScene(e.target.checked)}
      />
      zusätzlich in der Szene anzeigen
    </label>
  );
  return { addDummyCheckbox, dummy3d, setDummy3d };
};

export const Model3dInput = ({ property, setSelected, nodeIndex, isTopNode }) => {
  const [changeCounter, setChangeCounter] = useState(Math.random());
  const { addDummyCheckbox, setDummy3d } = useDummy3dCloneInScene({
    node: property.node,
    isTopNode,
  });
  return (
    <React.Fragment>
      <AbstractUploadInput
        property={property}
        incUpdate={(setUploading, setErrorMessage) => setChangeCounter(changeCounter + 1)}
        preview={({ property, setUploading, setErrorMessage, children }) => (
          <PreviewStage
            appScene={APP.scene}
            changeDependencies={[changeCounter, nodeIndex, APP.sceneNode.globalChangeCounter]}
            title={property.get()}
            className="model-preview"
            initStage={(stage) => {
              const url = property.getUriEncoded() + "?" + changeCounter;
              if (url) {
                const materialMap = property.node.MaterialMap;
                console.log("reset preview stage, materialMap=", materialMap);
                const materialFactory = materialMap
                  ? new ReplacingMaterialFactory(materialMap, UniversalLoader.getMaterialFactory())
                  : null;
                // if (property.node.Key) {
                //     if (sceneNode.metadata.ModelMaterialRelation) {
                //         const mmr = sceneNode.metadata.ModelMaterialRelation.find(mmr => mmr.Model.Key == property.node.Key);
                //         if (mmr) {
                //             console.log('verwendete Material Map', mmr.MaterialMap);
                //             // materialFactory = new ReplacingMaterialFactory(mmr.MaterialMap, UniversalLoader.getMaterialFactory());
                //         }
                //     }
                // }
                UniversalLoader.loadModelPromise(url, materialFactory)
                  .then((object3d) => {
                    setUploading(false);
                    if (stage.scene == null) {
                      return;
                    }
                    setDummy3d(object3d);
                    // const modelDataBefore = _.clone(property.node.ModelData);
                    APP.modelsHelper.setModelDataFromObject(property.node.meta, object3d);
                    // if (!Commons.isEqualEpsilon(modelDataBefore, property.node.ModelData)) {
                    //     // property.node.saveToServer();
                    // }
                    APP.modelsHelper.applyToObject3d(property.node.meta, object3d);
                    stage.scene.add(object3d);
                    stage.zoomTo(object3d);
                    const sphere = Scenes.boundingSphere(object3d);
                    stage.addGridSkyAndGround(sphere.radius);
                    // stage.autoRotate();

                    property.node.object3d = object3d;
                    APP.sceneNode.forceUiUpdate();

                    // _.delay(()=>Debugs.checkVisibility(object3d,stage.camera,stage.scene),1000);
                  })
                  .catch((error) => {
                    setUploading(false);
                    setErrorMessage(error);
                  });
              } else {
                setUploading(false);
                setErrorMessage("no url");
              }
            }}
          ></PreviewStage>
        )}
      ></AbstractUploadInput>
      {addDummyCheckbox}
    </React.Fragment>
  );
};
